// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { Button as KButton } from '@progress/kendo-vue-buttons';
/**
 * @hidden
 */
var PagerNavigationButtonVue2 = {
  name: 'KendoPagerNavigationButton',
  props: {
    title: String,
    disabled: Boolean,
    icon: String,
    svgIcon: Object,
    page: Number,
    size: String
  },
  inject: {
    kendoLocalizationService: {
      default: null
    },
    kendoIntlService: {
      default: null
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  methods: {
    changePage: function changePage(e) {
      e.preventDefault();
      this.$emit('pagechange', this.$props.page, e);
    }
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    return h(KButton, {
      fillMode: 'flat',
      attrs: this.v3 ? undefined : {
        fillMode: 'flat',
        themeColor: 'base',
        size: this.$props.size,
        rounded: null,
        ariaLabel: this.title,
        icon: this.icon,
        svgIcon: this.svgIcon,
        title: this.title,
        disabled: this.disabled,
        role: "button"
      },
      themeColor: 'base',
      size: this.$props.size,
      rounded: null,
      "class": 'k-pager-nav',
      ariaLabel: this.title,
      icon: this.icon,
      svgIcon: this.svgIcon,
      title: this.title,
      disabled: this.disabled,
      role: "button",
      onClick: this.changePage,
      on: this.v3 ? undefined : {
        "click": this.changePage
      }
    });
  }
};
/**
 * @hidden
 */
var PagerNavigationButton = PagerNavigationButtonVue2;
export { PagerNavigationButton, PagerNavigationButtonVue2 };